import React from 'react'
import { Link, useLocation } from 'react-router-dom';
// import sanityClient from '../Client'

function Hero({ tag, description }) {

    const location = useLocation();
    // const pathname = location.pathname.split('/')
    // const [tags, setTags] = useState([])
    // const [selectedTag, setSelectedTag] = useState(pathname[pathname.length - 1])
    // const navigate = useNavigate()

    // useEffect(() => {
    //     sanityClient.fetch(`
    //     *[_type == 'category']{title}
    //     `).then((data) => setTags(data)).catch(err => console.error(err))
    // }, [])

    // const handleTagChange = (e) => {
    //     const selectedTagVal = e.target.value;
    //     setSelectedTag(selectedTagVal)
    //     if (selectedTagVal === 'Default') {
    //         navigate(`/blogs/`)

    //     } else {

    //         navigate(`/blogs/tags/${selectedTagVal}`)
    //     }
    // }

    return (
        <section className=' lg:min-h-[200px] border-b border-[#ABABAB] mb-5 px-4'>
            <div className='container mx-auto flex justify-between'>
                <div>

                    {location.pathname.startsWith("/blogs/tags/") && <Link to="/blogs">← Back to Blogs</Link>}

                    <h1 className='text-[48px] md:text-[64px] lg:text-[72px] font-bold leading-[1.2] text-center md:text-left text-gray-200'>
                        {location.pathname.startsWith("/blogs/tags/") ? tag : 'OUR BLOGS'}
                    </h1>

                    {/* Set the description for Blog Collection page */}
                    <p className='text-gray-300 text-center md:text-left'>
                        {location.pathname.startsWith("/blogs/tags/") ? description : 'Articles by BlogCode'}
                    </p>

                    <h3 className='text-2xl font-semibold text-center md:text-left text-gray-300'>
                        {location.pathname.startsWith("/blogs/tags/") && `Recent Articles in ${tag}`}
                    </h3>
                </div>
                {/* <div>
                    <label htmlFor="select" className="text-sm font-medium text-gray-400">Search a tag:</label>
                    <select id="select" name="select" className="mt-1 block bg-neutral-200 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        value={selectedTag}
                        onChange={handleTagChange}
                    >
                        <option>Default</option>
                        {tags.map(tag =>
                            <option key={tag.title}>
                                {tag.title}
                            </option>
                        )}
                    </select>
                </div> */}
            </div>
        </section >
    )
}

export default Hero